import React, { useRef } from "react";
import {
  Typography,
  Box,
  Grid,
  Stack,
  Button,
  Dialog,
  Divider,
  IconButton,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import moment from "moment";
import { ToWords } from "to-words";
import "../../../Style/pagestyle.scss";
import { BiMinusCircle } from "react-icons/bi";
import WingdingImage from "../../../Assets/tacteing.jpg";
import LogoSchool from "../../../Assets/goglobal-school.png";
import { currencyFormat, currencyFormatRiel } from "../../../Function/DynamicFn";

const toWords = new ToWords({
  localeCode: "en-US",
  converterOptions: {
    currency: false,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: true,
  },
});

export default function PrintInvoice({ open, handleClose, editData }) {


  // console.log("paymentDate :", editData?.paymentDate);

  console.log("PrintInvoice",editData)
  // console.log("paymentDate :", moment("2025-01-10 05:27:07 pm").format("DD-MMM-YYYY hh:mm:ss a"));

  const totalAdditionalFee = editData?.additionalFee.reduce((a, b) => a + b.total, 0);

  const getPayAs = () => {
    if (editData?.groupFeeType === "Month") return "Month";
    if (editData?.groupFeeType === "Quarter") return "Quarter";
    if (editData?.groupFeeType === "Term") return "Semester";
    return "Year";
  }

  // "Month", "Term", "Quarter", "Year"
  // print
  const componentRef = useRef();
  const reactToPrintContent = () => {
    return componentRef.current;
  };

  const reactToPrintTrigger = () => {
    return (
      <Button
        sx={{
          width: "20%",
          padding: "6px",
          borderRadius: "10px",
          color: "white",
          backgroundColor: "#0f81c2 !important",
        }}
      >
        Print
      </Button>
    );
  };
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">View invoice</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ marginTop: "10px" }}>
          <Grid container>
            <Grid item xs={4}>
              <Stack direction="row" justifyContent="left">
                <Stack direction="column" sx={{ paddingLeft: "20px" }}>
                  <Stack direction="row" justifyContent="center">
                    <img
                      src={LogoSchool}
                      style={{ marginTop: "16px", width: "125px" }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
                <Typography sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }} align="center" >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }} align="center" >
                  Kingdom Of Cambodia
                </Typography>
                <Typography sx={{ fontSize: "14px", fontFamily: "KhmerOsMuol" }} align="center" >
                  ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography sx={{ fontSize: "14px", fontFamily: "GothicBoldRegular" }} align="center" >
                  Nation Religions King
                </Typography>
                <Stack direction="row" justifyContent="center">
                  <img alt="Image" src={WingdingImage} className="print-invoice-tackteng" />
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }}  >
                      ឈ្មោះសហគ្រាស :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }}  >
                      ហ្គោ គ្លូបប៊ល ស្គូល
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      អាសយដ្ឋាន៖
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      ភូមិថ្មី សង្កាត់ស្វាយដង្គំ
                    </Typography>
                  </Stack>
                  <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                    ក្រុងសៀមរាប ខេត្តសៀមរាប
                  </Typography>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      Tel :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      076 777 1168 | 085 705 555
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      VATTIN :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}  >
                      B116-901504283
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Typography sx={{ fontFamily: "Bayon", fontSize: "14px" }} align="center" >
                    <u>វិក្កយបត្រ</u>
                  </Typography>
                  <Typography sx={{ fontFamily: "Baloopaaji", fontSize: "14px", fontWeight: "bold", }} align="center" >
                    Invoice
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={0.5}>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      N° :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {moment(editData?.date).format("YYYY")}{editData?.invoiceId?.toString()?.padStart(6, '0')}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      Bill To :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}  >
                      {editData?.billTo?.lastName + " " + editData?.billTo?.firstName}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      Payment Date :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {moment(editData?.paymentDate).format("DD-MMM-YYYY hh:mm a")}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ marginTop: "15px" }}>
            <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
              ព័ត៌មានសិស្ស/Student Information
            </Typography>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            <Grid container>
              <Grid item xs={6}>
                <Stack spacing={0.5} direction="column" sx={{ marginTop: "4px" }} >
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      ឈ្មោះជាភាសាខ្មែរ/Full Name :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {editData?.studentId?.lastName + " " + editData?.studentId?.firstName}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      អត្តលេខ/Khmer ID :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.studentId?.student_id}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      ភេទ :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {editData?.studentId?.gender}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      កម្រិត/Levels :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.classId?.gradeId?.gradeName + " " + editData?.classId?.className}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack spacing={0.5} direction="column" sx={{ marginTop: "4px" }} >
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      ឈ្មោះឡាតាំង/Latin :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {editData?.studentId?.englishName}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }}>
                      ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {moment(editData?.studentId?.dob).format("DD-MMM-YYYY")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px", fontWeight: "bold", }} >
                      ពេលសិក្សា/Shift Time :
                    </Typography>
                    <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }} >
                      {editData?.enrollmentId?.classId?.shiftId?.shiftNameKh}
                    </Typography>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Typography
                      sx={{
                        fontFamily: "Siemreap",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      លេខទូរស័ព្ទ/Tel :
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      {editData?.billTo?.tel}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "15px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ការបង់ថ្លៃ/Payment
              </Typography>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
          </Box>
          <table className="print-invoice-table1">
            <tr>
              <th style={{ width: "5%" }} align="left">
                ល.រ
              </th>
              <th style={{ width: "20%" }} align="left">
                បង់ថ្លៃ/Pay To
              </th>
              <th style={{ width: "20%" }} align="left">
                បរិយាយ/Desciption
              </th>
              <th style={{ width: "15%" }} align="left">
                ចាប់ទី/Start Date
              </th>
              <th style={{ width: "15%" }} align="left">
                រហូតដល់/End Date
              </th>
              <th style={{ width: "25%" }} align="right">
                សរុប/Total Amount
              </th>
            </tr>

            {
              editData?.netAmount > 0 &&
              <tr>
                <td align="left">{1}</td>
                <td align="left">
                  ថ្លៃសិក្សា/Tuition Fee
                </td>
                <td align="left">1 {getPayAs()} </td>

                <td align="left">
                  {editData?.startDate ? moment(editData?.startDate).format("DD-MM-YYYY") : ""}
                </td>
                <td align="left">
                  {editData?.endDate ? moment(editData?.endDate).format("DD-MM-YYYY") : ""}
                </td>
                <td align="right">
                  $ {currencyFormat(parseFloat(editData?.netAmount))}
                </td>
              </tr>
            }

            {editData?.additionalFee?.map((row, index) => {
              return (
                <tr key={index}>
                  <td align="left">{index + editData?.netAmount > 0 ? 2 : 1}</td>

                  <td align="left">
                    {row?.incomeHead?.incomeHead ? row?.incomeHead?.incomeHead : "ថ្លៃសិក្សា/Tuition Fee"}
                  </td>

                  <td align="left">
                    {/* {row?.countMonth} Month */}
                    { `${row?.countMonth} ${row?.incomeHead?.unit}`}
                  </td>

                  <td align="left">
                    {row?.startDate ? moment(row?.startDate).format("DD-MM-YYYY") : ""}
                  </td>

                  <td align="left">
                    {row?.endDate ? moment(row?.endDate).format("DD-MM-YYYY") : ""}
                  </td>

                  <td align="right">
                    $ {currencyFormat(parseFloat(row?.total))}
                  </td>

                </tr>
              );
            })}
          </table>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (ដុល្លារ)/Total Amount ($) :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                }}
              >
                $ {currencyFormat(parseFloat(editData?.netAmount + totalAdditionalFee))}
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ padding: "4px" }}
            >
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                សរុប (រៀល)/Total Amount (Riels) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {currencyFormatRiel(parseFloat((editData?.netAmount + totalAdditionalFee) * editData?.exchangeRate))} ៛
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>
          <Box>
            <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
              <Typography
                sx={{
                  fontFamily: "Siemreap",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
              </Typography>
              <Typography sx={{ fontFamily: "Siemreap", fontSize: "12px" }}>
                {toWords.convert(parseFloat(editData?.netAmount + totalAdditionalFee))}{" "}
                Dollar Only
              </Typography>
            </Stack>
            <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
          </Box>

          <Box sx={{ marginTop: "50px" }}>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <Box sx={{ border: "3px double #000", padding: "8px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Bayon",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Siemreap",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    All processed payments will not be refunded, transfered, or
                    kept.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      អ្នកបង់ប្រាក់
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Payer)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack
                  direction="column"
                  spacing={0.2}
                  sx={{ marginTop: "20px" }}
                >
                  <Divider sx={{ borderBottom: "1px solid #000" }} />
                  <Stack direction="row" spacing={0.2}>
                    <Typography sx={{ fontFamily: "Bayon", fontSize: "12px" }}>
                      បេឡាធិការ
                    </Typography>
                    <Typography
                      sx={{ fontFamily: "Siemreap", fontSize: "12px" }}
                    >
                      (Cashier)
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* ============================================ code to print =============================================== */}

        <Box sx={{ display: "none" }}>
          <Box className="print-invoice-container" ref={componentRef}>
            <Box sx={{ marginTop: "10px" }}>
              <Grid container>
                <Grid item xs={4}>
                  <Stack direction="row" justifyContent="left">
                    <Stack direction="column" sx={{ paddingLeft: "20px" }}>
                      <Stack direction="row" justifyContent="center">
                        <img src={LogoSchool} className="print-invoice-logo" />
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    <Typography className="print-invoice-title-kh">
                      ព្រះរាជាណាចក្រកម្ពុជា
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Kingdom Of Cambodia
                    </Typography>
                    <Typography className="print-invoice-title-kh">
                      ជាតិ​ សាសនា ព្រះមហាក្សត្រ
                    </Typography>
                    <Typography className="print-invoice-title-en">
                      Nation Religions King
                    </Typography>
                    <Stack direction="row" justifyContent="center">
                      <img
                        alt="Image"
                        src={WingdingImage}
                        className="print-invoice-tackteng"
                      />
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>

              <Box sx={{ marginTop: "20px" }}>
                <Grid container>
                  <Grid item xs={4}>
                    <Stack direction="column" spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះសហគ្រាស :
                        </Typography>
                        <Typography className="print-invoice-header-title-bold">
                          ហ្គោ គ្លូបប៊ល ស្គូល
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          អាសយដ្ឋាន៖
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          ភូមិថ្មី សង្កាត់ស្វាយដង្គំ
                        </Typography>
                      </Stack>
                      <Typography className="print-invoice-header-title">
                        ក្រុងសៀមរាប ខេត្តសៀមរាប
                      </Typography>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title">
                          Tel :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          076 777 1168 | 085 705 555
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          VATTIN :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          B116-901504283
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Typography className="print-invoice-header-center-title-kh">
                        វិក្កយបត្រ
                      </Typography>
                      <Typography className="print-invoice-header-center-title">
                        Invoice
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={4}>
                    <Stack direction="column" spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          N° :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(editData?.date).format("YYYY")}{editData?.invoiceId?.toString()?.padStart(6, '0')}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Bill To :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.billTo?.lastName + " " + editData?.billTo?.firstName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          Payment Date :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(editData?.paymentDate).format(
                            "DD-MMM-YYYY hh:mm a"
                          )}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ព័ត៌មានសិ្ស/Student Information
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
                <Grid container>
                  <Grid item xs={6}>
                    <Stack direction="column" sx={{ marginTop: "4px" }} spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះជាភាសាខ្មែរ/Full Name :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.lastName + " " + editData?.studentId?.firstName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          អត្តលេខ/Khmer ID :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.student_id}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ភេទ :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.gender}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          កម្រិត/Levels :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.classId?.gradeId?.gradeName + " " + editData?.classId?.className}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={6}>
                    <Stack direction="column" sx={{ marginTop: "4px" }} spacing={0.5}>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ឈ្មោះឡាតាំង/Latin :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.studentId?.englishName}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ថ្ងៃខែឆ្នាំកំណើត/Date of Birth :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {moment(editData?.studentId?.dob).format(
                            "DD-MMM-YYYY"
                          )}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          ពេលសិក្សា/Shift Time :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.enrollmentId?.classId?.shiftId?.shiftNameKh}
                        </Typography>
                      </Stack>
                      <Stack direction="row" spacing={0.5}>
                        <Typography className="print-invoice-header-title-bold">
                          លេខទូរស័ព្ទ/Tel :
                        </Typography>
                        <Typography className="print-invoice-header-title">
                          {editData?.billTo?.tel}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ marginTop: "15px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ការបង់ថ្លៃ/Payment
                </Typography>
                <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
              </Box>
            </Box>

            <table className="print-invoice-table">
              <tr>
                <th style={{ width: "5%", }} align="left">
                  ល.រ
                </th>
                <th style={{ width: "20%" }} align="left">
                  បង់ថ្លៃ/Pay To
                </th>
                <th style={{ width: "20%" }} align="left">
                  បរិយាយ/Desciption
                </th>
                <th style={{ width: "15%" }} align="left">
                  ចាប់ទី/Start Date
                </th>
                <th style={{ width: "15%" }} align="left">
                  រហូតដល់/End Date
                </th>
                <th style={{ width: "25%" }} align="right">
                  សរុប/Total Amount
                </th>
              </tr>

              {
                editData?.netAmount > 0 &&
                <tr>
                  <td align="left">{1}</td>
                  <td align="left">
                    ថ្លៃសិក្សា/Tuition Fee
                  </td>
                  <td align="left">1 {getPayAs()} </td>
                  <td align="left">
                    {editData?.startDate ? moment(editData?.startDate).format("DD-MM-YYYY") : ""}
                  </td>
                  <td align="left">
                    {editData?.endDate ? moment(editData?.endDate).format("DD-MM-YYYY") : ""}
                  </td>
                  <td align="right">
                    $ {currencyFormat(parseFloat(editData?.netAmount))}
                  </td>
                </tr>
              }

              {editData?.additionalFee?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td align="left">{index + editData?.netAmount > 0 ? 2 : 1}</td>

                    <td align="left">
                      {row?.incomeHead?.incomeHead ? row?.incomeHead?.incomeHead : "ថ្លៃសិក្សា/Tuition Fee"}
                    </td>

                    <td align="left">
                      {row?.countMonth} Month
                    </td>

                    <td align="left">
                      {row?.startDate ? moment(row?.startDate).format("DD-MM-YYYY") : ""}
                    </td>

                    <td align="left">
                      {row?.endDate ? moment(row?.endDate).format("DD-MM-YYYY") : ""}
                    </td>

                    <td align="right">
                      $ {currencyFormat(parseFloat(row?.total))}
                    </td>

                  </tr>
                );
              })}
            </table>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  សរុប (ដុល្លារ)/Total Amount ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  $ {currencyFormat(parseFloat(editData?.netAmount + totalAdditionalFee))}
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ padding: "4px" }}
              >
                <Typography className="print-invoice-header-title-bold">
                  សរុប (រៀល)/Total Amount (Riels) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  {currencyFormatRiel(parseFloat((editData?.netAmount + totalAdditionalFee) * editData?.exchangeRate))} ៛
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box>
              <Stack direction="row" spacing={0.4} sx={{ padding: "4px" }}>
                <Typography className="print-invoice-header-title-bold">
                  ចំនួនទឹកប្រាក់ជាអក្សរ (ដុល្លារ)/Amount In Letter ($) :
                </Typography>
                <Typography className="print-invoice-header-title">
                  {toWords.convert(
                    editData?.netAmount ? parseFloat(editData?.netAmount + totalAdditionalFee) : 0
                  )}{" "}
                  Dollar Only
                </Typography>
              </Stack>
              <Divider sx={{ borderBottom: "1px solid #cccccc" }} />
            </Box>
            <Box sx={{ marginTop: "50px" }}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Box className="print-invoice-box-bottom">
                    <Typography
                      className="print-invoice-footer-kh"
                      sx={{ textAlign: "center" }}
                    >
                      ប្រាក់បង់រូចមិនអាចដក ផ្ទេរ និងរក្សាទុកបានទេ
                    </Typography>
                    <Typography
                      className="print-invoice-footer-en"
                      sx={{ textAlign: "center" }}
                    >
                      All processed payments will not be refunded, transfered,
                      or kept.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        អ្នកបង់ប្រាក់
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Payer)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack
                    direction="column"
                    spacing={0.2}
                    sx={{ marginTop: "18px" }}
                  >
                    <Divider sx={{ borderBottom: "1px solid #000" }} />
                    <Stack direction="row" spacing={0.2}>
                      <Typography className="print-invoice-footer-kh">
                        បេឡាធិការ
                      </Typography>
                      <Typography className="print-invoice-footer-en">
                        (Cashier)
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>

        <Stack direction="row" justifyContent="right">
          <ReactToPrint
            removeAfterPrint
            content={reactToPrintContent}
            trigger={reactToPrintTrigger}
            documentTitle={`${editData?.studentId?.fullName}-invoice`}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
